module.exports = __webpack_public_path__ + "static/img/logo_26.cbc9cd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_26.png
// module id = YWBX
// module chunks = 1